module.exports = __webpack_public_path__ + "static/media/mob-bg.69a61365.png";